import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  templateUrl: './reservation-agreements.component.html',
  styleUrls: ['./reservation-agreements.component.scss'],
})
export class ReservationAgreementsComponent {
  isMobile$: Observable<boolean>;

  constructor(
    private router: Router,
    private deviceDetectionService: DeviceDetectionService
  ) {
    this.isMobile$ = this.deviceDetectionService.isMobileViewport();
  }

  createNewReservationAgreement() {
    this.router.navigate(['/gx/rental-agreements/new']);
  }
}
